import React from "react";
import {
    Box,
    Card,
    CardContent,
    Divider,
    Grid,
} from '@mui/material';


const DataTicketSettingCard = (props) => {
    const { classes, item } = props;
    const ticketSettingInfo = item.actualData.prices;
    return (
        <>
            <Card
                classes={{ root: classes.paperContent }}
                sx={{ width: '100%' }}>
                <CardContent sx={{ p: 2 }} className={classes.cardContent}>
                    <Grid container spacing={2}>
                        <Grid item xs={4} className={classes.textCenter}>
                            <Box className={classes.fontWeight600}> Friday Night </Box>
                            <Divider />
                            {ticketSettingInfo && ticketSettingInfo.length > 0 ? ticketSettingInfo.map((val, i) => {
                                if (val.ticketNightID === 1) {
                                    return (
                                        <Box key={i}>
                                            <Box>
                                                <Box component="span" className={classes.fontWeight500}>Sub Type:</Box> {val.subTypeName}
                                            </Box>
                                            <Box>
                                                <Box component="span" className={classes.fontWeight500}>Ticket price:</Box> {val.price}
                                            </Box>
                                            <Divider />
                                        </Box>)
                                }

                            }) : null}
                        </Grid>
                        <Grid item xs={4} className={classes.textCenter}>
                            <Box className={classes.fontWeight600}>Saturday Night</Box>
                            <Divider />
                            {ticketSettingInfo && ticketSettingInfo.length > 0 ? ticketSettingInfo.map((val, i) => {
                                if (val.ticketNightID === 2) {
                                    return (
                                        <Box key={i}>
                                            <Box>
                                                <Box component="span" className={classes.fontWeight500}>Sub Type:</Box> {val.subTypeName}
                                            </Box>
                                            <Box>
                                                <Box component="span" className={classes.fontWeight500}>Ticket price:</Box> {val.price}
                                            </Box>
                                            <Divider />
                                        </Box>
                                    )
                                }

                            }) : null}
                        </Grid>
                        <Grid item xs={4} className={classes.textCenter}>
                            <Box className={classes.fontWeight600}>Sunday Night</Box>
                            <Divider />
                            {ticketSettingInfo && ticketSettingInfo.length > 0 ? ticketSettingInfo.map((val, i) => {
                                if (val.ticketNightID === 3) {
                                    return (
                                        <Box key={i}>

                                            <Box>
                                                <Box component="span" className={classes.fontWeight500}>Sub Type:</Box> {val.subTypeName}
                                            </Box>
                                            <Box>
                                                <Box component="span" className={classes.fontWeight500}>Ticket price:</Box> {val.price}
                                            </Box>
                                            <Divider />
                                        </Box>

                                    )
                                }
                            }) : null}
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </>
    )
}

export default DataTicketSettingCard;